/**
 * Created by Ivan on 21.08.2025
 */

const WeeklyGoal = function (config) {
    cleverapps.EventEmitter.call(this);
    this.type = config[0];
    this.target = config[1];
    this.collected = config[2];
    this.data = config[3];
};

WeeklyGoal.prototype = Object.create(cleverapps.EventEmitter.prototype);
WeeklyGoal.prototype.constructor = WeeklyGoal;

WeeklyGoal.prototype.getInfo = function () {
    const info = [this.type, this.target, this.collected ? 1 : 0];
    if (this.data !== undefined) {
        info.push(this.data);
    }
    return info;
};

WeeklyGoal.prototype.isFinished = function () {
    return this.calcProgress() >= this.target;
};

WeeklyGoal.prototype.setReward = function (reward) {
    this.reward = new RewardsList(reward, {
        event: cleverapps.EVENTS.EARN.WEEKLY_GOALS,
        toMainWorld: !cleverapps.meta.getSelectedLocation().locationConfig.isMain,
        toBubbleStack: true
    });
};

WeeklyGoal.prototype.countVisibleRewards = function () {
    return this.reward.listRewards().filter((reward) => reward.getAmount() && !RewardTypes[reward.type].invisible).length;
};

WeeklyGoal.prototype.complete = function () {
    const amount = this.target - this.calcProgress();
    cleverapps.weeklyGoals.addProgress(this.type, amount, false, this.data);
};

WeeklyGoal.prototype.isRewardedAvailable = function () {
    return this.isFinished() && !this.collected;
};

WeeklyGoal.prototype.checkComplete = function (amount) {
    const value = this.calcProgress();
    return value < this.target && value + amount >= this.target;
};

WeeklyGoal.prototype.createNotification = function () {
    const title = this.getTitle();

    cleverapps.notification.create(Messages.get(title.text, title.replace), {
        image: bundles.notification.frames.weekly_goals_icon_png
    });
};

WeeklyGoal.prototype.givePrize = function () {
    if (this.isRewardedAvailable()) {
        this.collected = true;
        this.reward.receiveRewards();

        cleverapps.weeklyGoals.onCollect(this.type);
        this.trigger("givePrize");
    }
};

WeeklyGoal.prototype.getTitle = function () {
    const replace = { target: this.target };

    const config = cleverapps.weeklyGoals.config[this.type];
    if (config.param) {
        replace[config.param] = config.rawParam ? this.getIconText() : Messages.get(`WeeklyGoal.${this.type}.${this.data}`);
    }

    return {
        text: `WeeklyGoal.${this.type}.Title`,
        replace
    };
};

WeeklyGoal.prototype.getIconText = function () {
    return cleverapps.weeklyGoals.config[this.type].rawParam ? cleverapps.weeklyGoals.getLocalizedData(this.type, this.data).toUpperCase() : undefined;
};

WeeklyGoal.prototype.getIcon = function () {
    const icon = cleverapps.weeklyGoals.config[this.type].icon;
    return typeof icon === "object" ? icon[this.data] : icon;
};

WeeklyGoal.prototype.calcProgress = function () {
    return Math.min(this.target, cleverapps.weeklyGoals.calcProgress(this.type, this.data));
};

WeeklyGoal.prototype.getHint = function () {
    const config = cleverapps.weeklyGoals.config[this.type];
    if (config && config.hint && typeof WeeklyGoalsHints !== "undefined") {
        return WeeklyGoalsHints[config.hint];
    }
    return null;
};

WeeklyGoal.prototype.hasHint = function () {
    if (!cleverapps.meta.getSelectedLocation().locationConfig.isMain) {
        return false;
    }
    return Boolean(this.getHint());
};

WeeklyGoal.prototype.showHint = function () {
    const hint = this.getHint();
    if (hint) {
        return hint();
    }
    return false;
};
